import React, { useState } from "react";
import { FiAlertTriangle, FiX } from "react-icons/fi";
import toast from "react-hot-toast";
import { deleteEvent } from "../../../api/eventApi";

const EventDeleteModal = ({ isOpen, onClose, onSuccess, event }) => {
  const [loading, setLoading] = useState(false);

  if (!isOpen || !event) return null;

  const handleDelete = async () => {
    setLoading(true);
    try {
      const idToDelete = event.id || event.eventId;
      const res = await deleteEvent(idToDelete);
      toast.success(res?.message || "Event deleted successfully");
      if (onSuccess) onSuccess();
      onClose();
    } catch (err) {
      toast.error(err.message || "Failed to delete event");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Modal Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 bg-red-50/70">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-red-100 text-red-600 flex items-center justify-center font-bold flex-shrink-0">
              <FiAlertTriangle size={20} />
            </div>
            <div>
              <h3 className="text-base font-bold text-gray-900">Delete Event</h3>
              <p className="text-xs text-red-600">Irreversible Action</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 p-1.5 rounded-lg hover:bg-gray-100 transition"
          >
            <FiX size={18} />
          </button>
        </div>

        {/* Modal Body */}
        <div className="p-6 space-y-4">
          <p className="text-sm text-gray-700 leading-relaxed">
            Are you sure you want to permanently delete event{" "}
            <strong className="text-gray-900 font-bold">
              &quot;{event.eventName || event.eventId}&quot;
            </strong>
            ?
          </p>

          <div className="bg-amber-50 border border-amber-200 rounded-xl p-3.5 text-xs text-amber-800 space-y-1">
            <p className="font-semibold flex items-center gap-1.5 text-amber-900">
              ⚠️ Warning: Cascading Deletion
            </p>
            <p className="leading-relaxed">
              Deleting this event will also delete all associated user event points, daily check-in histories, and prize claims. This action cannot be undone.
            </p>
          </div>
        </div>

        {/* Modal Footer */}
        <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex items-center justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="px-4 py-2 text-xs font-semibold text-gray-600 bg-white border border-gray-200 hover:bg-gray-100 rounded-xl transition"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleDelete}
            disabled={loading}
            className="px-5 py-2 text-xs font-bold text-white bg-red-600 hover:bg-red-700 disabled:opacity-50 rounded-xl transition shadow-sm flex items-center gap-2"
          >
            {loading ? (
              <>
                <div className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                Deleting...
              </>
            ) : (
              "Yes, Delete Event"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EventDeleteModal;
